import React from 'react';
import PropTypes from 'prop-types';

import { priceFormat } from 'apps/products/utils/priceFormat';

export default function PreviousPrice(props) {
  const { previousPrice, zeroAfterPound } = props;

  return previousPrice
    ? <span className="fop-old-price">{priceFormat({ value: previousPrice, zeroAfterPound })}</span>
    : null;
}

PreviousPrice.propTypes = {
  previousPrice: PropTypes.number,
  zeroAfterPound: PropTypes.bool,
};
